module.exports = __webpack_public_path__ + "static/media/list-inactive.2474817e.svg";